import { isNumber } from "../omnia";
import { CroppingInfo } from "./cropping-info";
import { NotificationGroup } from "./types";

export function checkBoundaryAreas(cropping: CroppingInfo[]): NotificationGroup {

    let issues = cropping.filter(c => {

        if (!isNumber(c.boundaryArea)) return false;

        let diff = Math.abs(c.boundaryArea - c.area);
        let pct = diff / c.area;

        return (pct >= 0.1);

    });

    if (!issues.length) {
        return null;
    }

    let details = issues.map(i => {
        return {
            text: i.description + ` - boundary area: ${i.boundaryArea} ha`,
        };
    });

    const summary = "Boundary areas differ from cropping areas";
    const description = "Some of the crops have a boundary area that is significantly smaller or larger than its cropping area. This could lead to discrepancies when using map-based plans.";

    return {
        id: "boundary-area",
        summary,
        description,
        error: false,
        details: details,
    };

}
